import localForage from 'localforage';

const store = localForage.createInstance({
  name: 'app',
});

const mapStateForCache = (state) => {
  console.log('storage - mapping state for cache', state)
  const mappedState = {
    projects: state.projects,
    userProfile: state.userProfile
  }
  return mappedState
};

export const setState = (state) => {
  const cachedState = mapStateForCache(state);
  return store.setItem('state', cachedState);
};

export const getState = () => store.getItem('state');

export const deleteState = () => store.removeItem('state');